import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Row, Col, BreadcrumbItem } from "reactstrap";

const Breadcrumb = ({ title, breadcrumbItems }) => {
  return (
    <Row className="align-items-center">
      <Col sm={6}>
        <div className="page-title-box">
          <h4 className="font-size-18">{title}</h4>

          <ol className="breadcrumb mb-0">
            {/* Dashboard */}
            <BreadcrumbItem>
              <Link to="/dashboard">Dashboard</Link>
            </BreadcrumbItem>

            {/* Dynamic Items */}
            {breadcrumbItems &&
              breadcrumbItems.map((item, index) => (
                <BreadcrumbItem
                  key={index}
                  active={index === breadcrumbItems.length - 1}
                >
                  {item.link && index !== breadcrumbItems.length - 1 ? (
                    <Link to={item.link}>{item.title}</Link>
                  ) : (
                    item.title
                  )}
                </BreadcrumbItem>
              ))}
          </ol>
        </div>
      </Col>

      <Col sm={6}>
        <div className="float-end d-none d-md-block"></div>
      </Col>
    </Row>
  );
};

Breadcrumb.propTypes = {
  title: PropTypes.string,
  breadcrumbItems: PropTypes.array,
};

export default Breadcrumb;